export const useCartStore = defineStore('cart', () => {
  const dataStore = useDataStore();
  const DB = useDbStore();

  const addOrderNotificationItem = ref<ItemI | null>(null);

  const list = computed(() => {
    return [...Object.values(dataStore.localOrders), ...dataStore.cartOrders].sort((a, b) => {
      return new Date(a.created).getTime() - new Date(b.created).getTime();
    });
  });

  const discount = ref(0);

  const createOrder = async (item: ItemI, options: Partial<ServerOrderI> = {}, notify = false) => {
    const resp = dataStore.createOrder(item, options);
    resp.then(() => {
      if (options.approved || notify) {
        addOrderNotificationItem.value = item;
      }
    });

    return resp;
  };

  const updateOrder = async (id: string, options: Partial<ServerOrderI> = {}) => {
    const order = getUserOrderById(id);

    if (order) {
      const totalPrice = calculateOrderPrice({
        stickers: order.stickers,
        item: order.item,
      }, 0);
      const totalPriceAfterDiscount = calculateOrderPrice({
        stickers: order.stickers,
        item: order.item,
      }, dataStore.user?.loyaltyDiscount);
      return DB.updateOrder(order.id, {
        ...convertOrderToServerOrder(order),
        ...options,
        totalPrice,
        discount: +(totalPrice - totalPriceAfterDiscount).toFixed(2),
      });
    }
  };

  const addFilesToOrder = async (id: string, files: File[]) => {
    const order = getUserOrderById(id);
    if (order) {
      return await DB.addOrderFiles(id, files);
    }

    const localOrder = getLocalItemByLocalId(id);
    if (localOrder) {
      localOrder.files = [...localOrder.files, ...files];

      return localOrder;
    }
  };

  const removeFile = async (id: string, file: string | File) => {
    const order = getUserOrderById(id);
    if (order) {
      return await DB.removeOrderFile(id, file as string);
    }

    const localOrder = getLocalItemByLocalId(id);
    localOrder.files = localOrder.files.filter(f => f !== file);

    return localOrder;
  };

  const getLocalItemByLocalId = (id: string) => {
    return dataStore.localOrders[id];
  };

  const getUserOrderById = (id: string) => {
    return dataStore.orders[id];
  };

  const getItemById = (id: string) => {
    const dbOrder = getUserOrderById(id);
    if (dbOrder) return dbOrder;
    const localOrder = getLocalItemByLocalId(id);
    if (localOrder) return localOrder;

    console.info('no order with id: ', id);
    return null as unknown as OrderI;
    // return list.value.find(item => item.id === id) as OrderI;
  };

  const hasItem = (id: string) => {
    return !!getItemById(id);
  };

  const removeItem = async (id: string) => {
    // TODO: check if rewrite is needed
    const dbOrder = dataStore.orders[id];
    if (dbOrder) return DB.deleteOrder(id);

    if (dataStore.localOrders[id]) delete dataStore.localOrders[id];
  };

  const hasItemsAndApproved = computed(() => {
    const selected = list.value.filter(c => c.selectedInCart);

    return selected.length > 0
      && selected.every(c => c.approved)
      && selected.every(c => c.id || c.localId)
      && selected.every(c => c.files.length > 0);
  });

  const canPay = computed(() => {
    return dataStore.user
      && hasItemsAndApproved.value;
  });

  return {
    list,
    discount,
    hasItemsAndApproved,
    canPay,
    addOrderNotificationItem,
    createOrder,
    updateOrder,
    addFilesToOrder,
    removeFile,

    hasItem,
    getItemById,
    removeItem,
  };
});
